// extracted by mini-css-extract-plugin
module.exports = {"header":"infoRoute_header__1TJsy","logo":"infoRoute_logo__ZxDUV","description":"infoRoute_description__1cFAB"};